/**
 * Bildverwaltung für pixcapture.app
 * 
 * Jedes Bild hat:
 * - id: Eindeutige Kennung
 * - url: Bild-URL (Unsplash)
 * - alt: Alternativtext für Accessibility
 * - page: Seitenzugehörigkeit
 * - description: Optionale Beschreibung
 */

export interface ImageAsset {
  id: string;
  url: string;
  alt: string;
  page: string;
  description?: string;
}

// ========================================
// PIXCAPTURE.APP IMAGES (Self-Service)
// ========================================
export const pixCaptureImages: ImageAsset[] = [
  {
    id: "pixcap-001",
    url: "https://images.unsplash.com/photo-1739712039253-324be4f33543?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpcGhvbmUlMjBjYW1lcmElMjBwaG90b2dyYXBoeSUyMGhhbmRzfGVufDF8fHx8MTc2MjQxNDYyOXww&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "iPhone Camera Photography",
    page: "pixcapture",
    description: "Mit dem iPhone fotografieren",
  },
  {
    id: "pixcap-002",
    url: "https://images.unsplash.com/photo-1749898750456-156660b1ac80?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjB0YWtpbmclMjByZWFsJTIwZXN0YXRlJTIwcGhvdG98ZW58MXx8fHwxNzYyNDE0NjI5fDA&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Person Taking Real Estate Photo",
    page: "pixcapture",
    description: "Self-Service Immobilienfotografie",
  },
  {
    id: "pixcap-003",
    url: "https://images.unsplash.com/photo-1753685725168-10576bc8436f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwYXBhcnRtZW50JTIwcGhvdG98ZW58MXx8fHwxNzYyNDE0NjI5fDA&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Smartphone Apartment Photo",
    page: "pixcapture",
    description: "Wohnung mit Smartphone fotografieren",
  },
  {
    id: "pixcap-004",
    url: "https://images.unsplash.com/photo-1592920746120-6fbb741b4310?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBwaG90b2dyYXBoeSUyMGhvdXNlfGVufDF8fHx8MTc2MjQxNDYzMHww&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Mobile Photography House",
    page: "pixcapture",
    description: "Mobile Fotografie für Immobilien",
  },
  {
    id: "pixcap-005",
    url: "https://images.unsplash.com/photo-1655292913700-bbdb7c40adc2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpcGhvbmUlMjByZWFsJTIwZXN0YXRlJTIwaW50ZXJpb3J8ZW58MXx8fHwxNzYyNDE0NjMwfDA&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "iPhone Real Estate Interior",
    page: "pixcapture",
    description: "Innenräume mit iPhone",
  },
  {
    id: "pixcap-006",
    url: "https://images.unsplash.com/photo-1655457252959-7d5872e7fdb1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzZWxmJTIwc2VydmljZSUyMHBob3RvZ3JhcGh5JTIwYXBhcnRtZW50fGVufDF8fHx8MTc2MjQxNDYzMXww&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Self-Service Photography",
    page: "pixcapture",
    description: "Selbst fotografieren und hochladen",
  },
  {
    id: "pixcap-007",
    url: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDF8fHx8MTc2MjA5ODAwMnww&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Modern Living Room",
    page: "pixcapture",
    description: "Wohnzimmer fotografieren",
  },
  {
    id: "pixcap-008",
    url: "https://images.unsplash.com/photo-1654176154397-3133364f22e6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZWFsJTIwZXN0YXRlJTIwa2l0Y2hlbnxlbnwxfHx8fDE3NjIxMDExODJ8MA&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Real Estate Kitchen",
    page: "pixcapture",
    description: "Küche fotografieren",
  },
];

// ========================================
// HILFSFUNKTIONEN
// ========================================

/**
 * Erstellt die Bildstruktur für ScrollingImageStrip
 */
export function formatForScrollingStrip(images: ImageAsset[]) {
  return images.map((img) => ({
    id: img.id,
    url: img.url,
    alt: img.alt,
  }));
}
